import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0d6e288a"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6e288a')) {
      api.createRecord('0d6e288a', component.options)
    } else {
      api.reload('0d6e288a', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=0d6e288a", function () {
      api.rerender('0d6e288a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/service-satisfaction-questionnaire/Main.vue"
export default component.exports